import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MessagingChatService {
  public unseenMessagesSubject: Subject<any> = new Subject<any>();

  clear() {
    this.unseenMessagesSubject.complete();
    this.unseenMessagesSubject = new Subject<any>();
  }
}
